import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

function ScrollAppear({ children }) {
  const elementRef = useRef(null);
  const [style, setStyle] = useState({
    opacity: 1,
    transformOrigin: 'center top',
    transform: 'perspective(400px) translateZ(-50px) rotateX(10deg)',
  });
  useEffect(() => {
    const handleScroll = () => {
      if (!elementRef.current) return;

      const rect = elementRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const speedFactor = 0.8;
      const rawProgress = Math.min(Math.max(1 - rect.top / windowHeight, 0), 1);
      const progress = rawProgress ** speedFactor;
      const rotateX = 10 - 10 * progress;
      const translateZ = -50 + 50 * progress;

      setStyle({
        opacity: 1,
        transformOrigin: 'center top',
        transform: `perspective(400px) translateZ(${translateZ}px) rotateX(${rotateX}deg)`,
        transition: 'transform 0.6s ease-out',
        marginBottom: '2rem',
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      ref={elementRef}
      sx={{
        flexDirection: 'column',
        position: 'sticky',
        alignItems: 'center',
        display: 'flex',
        willChange: 'transform, opacity',
        ...style,
      }}
    >
      {children}
    </Box>

  );
}

ScrollAppear.propTypes = {
  children: PropTypes.node.isRequired,
};

ScrollAppear.defaultProps = {
};

export default ScrollAppear;
